export default __webpack_public_path__ + "static/media/DashboardnewIcon.842d1ef7.svg";